
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.268 6.403l-7.7 9.431a1.661 1.661 0 01-2.395.172l-4.261-3.831a1.77 1.77 0 01-.578-1.265A1.752 1.752 0 015.27 9.57l2.75 2.493 6.583-7.871a1.739 1.739 0 011.215-.627 1.785 1.785 0 011.29.467 1.72 1.72 0 01.16 2.37z"}})])
          )
        }
      }
    